var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLanding01Medium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 260,
    viewBox: "0 0 347 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1619)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_1_1619)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 327,
    height: 240,
    rx: 24,
    fill: "#E9F4FF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7188 49.793V51.5508H36.5859V49.793H43.5V45.7109H45.6484V49.793H52.7188ZM37.0547 44.3438C40.7461 43.748 43.3926 41.1016 43.4023 38.4453V37.1562H45.707V38.4453C45.707 41.1113 48.373 43.748 52.0938 44.3438L51.1562 46.1406C48.1777 45.5742 45.7266 43.8652 44.5547 41.5508C43.3926 43.8555 40.9707 45.584 37.9922 46.1406L37.0547 44.3438ZM63.7734 37.8398V39.5586H53.9102V37.8398H57.8555V35.9258H60.0234V37.8398H63.7734ZM54.8281 43.5625C54.8184 41.5898 56.498 40.2617 58.9102 40.2617C61.3125 40.2617 63.041 41.5898 63.0508 43.5625C63.041 45.5254 61.3125 46.8242 58.9102 46.8242C56.498 46.8242 54.8184 45.5254 54.8281 43.5625ZM56.6836 50.6523C56.6836 48.709 58.9785 47.5762 62.7188 47.5859C66.4492 47.5762 68.7441 48.709 68.7539 50.6523C68.7441 52.5664 66.4492 53.7188 62.7188 53.7188C58.9785 53.7188 56.6836 52.5664 56.6836 50.6523ZM56.8594 43.5625C56.8496 44.5977 57.6602 45.2031 58.9102 45.2031C60.1602 45.2031 61.0195 44.5977 61.0195 43.5625C61.0195 42.5078 60.1602 41.8828 58.9102 41.8828C57.6602 41.8828 56.8496 42.5078 56.8594 43.5625ZM58.9688 50.6523C58.959 51.5703 60.3359 52.0684 62.7188 52.0586C65.082 52.0684 66.4297 51.5703 66.4297 50.6523C66.4297 49.7148 65.082 49.2461 62.7188 49.2461C60.3359 49.2461 58.959 49.7148 58.9688 50.6523ZM63.8711 45.3203V43.582H66.4883V41.8438H63.8906V40.0859H66.4883V36.082H68.6562V47.3906H66.4883V45.3203H63.8711ZM85.8438 36.082V53.7578H83.6562V36.082H85.8438ZM71.7227 43.6016C71.7129 39.793 73.6562 37.3711 76.332 37.3711C78.9785 37.3711 80.9316 39.793 80.9414 43.6016C80.9316 47.4395 78.9785 49.8516 76.332 49.8516C73.6562 49.8516 71.7129 47.4395 71.7227 43.6016ZM73.8125 43.6016C73.8125 46.3164 74.8379 47.8887 76.332 47.8984C77.8164 47.8887 78.832 46.3164 78.832 43.6016C78.832 40.9062 77.8164 39.3242 76.332 39.3242C74.8379 39.3242 73.8125 40.9062 73.8125 43.6016ZM94.75 40.3203C94.7305 43.4746 96.3125 46.6582 99.0469 47.9766L97.7188 49.7148C95.8047 48.748 94.4277 46.8828 93.6758 44.6367C92.9043 47.0391 91.459 49.0312 89.4375 50.0469L88.1094 48.3086C90.9512 46.9609 92.5723 43.582 92.582 40.3203V37.5078H94.75V40.3203ZM100.102 53.7383V36.082H102.27V42.9961H104.984V44.8516H102.27V53.7383H100.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5137 69.9668V79.1953H45.4336V77.9375H42.918V77.1582H45.4336V69.9668H46.5137ZM46.8145 80.9453V81.8477H38.1738V78.293H39.2539V80.9453H46.8145ZM36.4238 75.5996C38.6934 75.5859 41.7285 75.5723 44.3398 75.2441L44.4082 76.0234C43.3213 76.1943 42.1865 76.3037 41.0723 76.3652V78.7715H39.9922V76.4199C38.7617 76.4746 37.5928 76.4814 36.5742 76.4746L36.4238 75.5996ZM40.416 70.459C42.1934 70.459 43.4102 71.3066 43.4238 72.5781C43.4102 73.877 42.1934 74.6836 40.416 74.6836C38.625 74.6836 37.4082 73.877 37.4082 72.5781C37.4082 71.3066 38.625 70.459 40.416 70.459ZM40.416 71.2793C39.2266 71.2656 38.4199 71.7988 38.4336 72.5781C38.4199 73.3711 39.2266 73.8906 40.416 73.8906C41.5645 73.8906 42.3848 73.3711 42.3984 72.5781C42.3848 71.7988 41.5645 71.2656 40.416 71.2793ZM59.707 76.1328V77.0078H54.6621V78.2793H58.2715V81.9434H50.0957V78.2793H53.6094V77.0078H48.5781V76.1328H59.707ZM51.1484 79.1406V81.0684H57.2188V79.1406H51.1484ZM58.2715 70.2539V73.0977H51.0938V74.3145H58.5312V75.1758H50.0273V72.3047H57.1914V71.0879H49.9863V70.2539H58.2715ZM62.6875 80.084L61.6211 83.8027H60.6094L61.3613 80.084H62.6875ZM78.9023 77.3223V78.2109H73.8438V82.1074H72.791V78.2109H67.7734V77.3223H78.9023ZM77.6445 75.1895V76.0645H69.2637V70.5273H77.5078V71.4023H70.3301V72.8242H77.2207V73.6855H70.3301V75.1895H77.6445ZM91.002 76.1328V77.0078H85.957V78.2793H89.5664V81.9434H81.3906V78.2793H84.9043V77.0078H79.873V76.1328H91.002ZM82.4434 79.1406V81.0684H88.5137V79.1406H82.4434ZM89.5664 70.2539V73.0977H82.3887V74.3145H89.8262V75.1758H81.3223V72.3047H88.4863V71.0879H81.2812V70.2539H89.5664ZM93.9824 80.084L92.916 83.8027H91.9043L92.6562 80.084H93.9824ZM99.5195 81L99.5059 80.0977L102.883 76.543C104.059 75.2988 104.619 74.6289 104.619 73.7129C104.619 72.7012 103.758 72.0312 102.65 72.0312C101.475 72.0312 100.723 72.7832 100.723 73.8906H99.5605C99.5469 72.1406 100.9 70.9648 102.691 70.9648C104.482 70.9648 105.768 72.168 105.768 73.7129C105.768 74.8203 105.248 75.6816 103.498 77.4863L101.229 79.8242V79.9062H105.945V81H99.5195ZM110.977 81.1367C108.775 81.1367 107.518 79.291 107.518 76.0508C107.518 72.8379 108.803 70.9648 110.977 70.9648C113.15 70.9648 114.436 72.8379 114.436 76.0508C114.436 79.291 113.164 81.1367 110.977 81.1367ZM110.977 80.043C112.398 80.043 113.232 78.6074 113.232 76.0508C113.232 73.4941 112.398 72.0312 110.977 72.0312C109.555 72.0312 108.707 73.4941 108.707 76.0508C108.707 78.6074 109.541 80.043 110.977 80.043ZM122.461 70.8828V71.7715H121.217V75.6543C121.784 75.6201 122.331 75.5723 122.857 75.5039L122.912 76.3242C120.547 76.6934 117.771 76.7207 115.803 76.7207L115.666 75.8184C116.151 75.8184 116.678 75.8184 117.238 75.8047V71.7715H116.008V70.8828H122.461ZM125.715 69.9531V77.459H124.635V75.2031H122.584V74.3145H124.635V73.0293H122.584V72.1406H124.635V69.9531H125.715ZM121.682 77.7188C124.225 77.7188 125.756 78.5117 125.756 79.8926C125.756 81.2871 124.225 82.0801 121.682 82.0801C119.139 82.0801 117.607 81.2871 117.607 79.8926C117.607 78.5117 119.139 77.7188 121.682 77.7188ZM121.682 78.5527C119.809 78.5527 118.66 79.0586 118.674 79.8926C118.66 80.7402 119.809 81.2324 121.682 81.2324C123.555 81.2324 124.689 80.7402 124.689 79.8926C124.689 79.0586 123.555 78.5527 121.682 78.5527ZM118.277 75.791C118.899 75.7773 119.542 75.7568 120.178 75.7227V71.7715H118.277V75.791ZM138.129 69.9531V82.1074H137.104V75.7363H135.312V81.4785H134.328V70.2266H135.312V74.8477H137.104V69.9531H138.129ZM132.742 71.4434V72.332H129.256V78.1836C130.931 78.1768 132.093 78.1152 133.439 77.8418L133.535 78.7441C132.072 79.0449 130.828 79.0996 128.969 79.0996H128.189V71.4434H132.742ZM149.682 71.1562V79.0586H144.062V71.1562H149.682ZM145.115 72.0176V78.1836H148.629V72.0176H145.115ZM153.373 69.9531V82.1348H152.293V69.9531H153.373ZM161.59 71.0605V76.6523H155.971V71.0605H161.59ZM157.023 71.9355V75.791H160.551V71.9355H157.023ZM164.953 69.9531V73.6582H166.785V74.5605H164.953V78.8672H163.887V69.9531H164.953ZM165.514 80.9453V81.8477H157.352V78.0195H158.404V80.9453H165.514Z",
    fill: "#999999"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_1619)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1619",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 327,
    height: 240
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 327,
    height: 240,
    rx: 32,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.049 165.782C260.718 147.637 313.954 118.34 350.2 92.9199L381.13 71.2288C383.675 69.4442 387.16 71.275 387.16 74.3831V164.837C387.16 166.092 386.543 167.273 385.509 167.983C316.705 215.22 233.716 223.864 223.24 211.96C215.508 203.173 210.536 181.92 208.584 169.917C208.293 168.123 209.342 166.405 211.049 165.782Z",
    fill: "#4DA9FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.959,
    y: 214.84,
    width: 19.2,
    height: 23.04,
    rx: 7.68,
    fill: "#242945"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.479,
    y: 214.84,
    width: 19.2,
    height: 23.04,
    rx: 7.68,
    fill: "#242945"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 111.16,
    width: 128.64,
    height: 115.2,
    rx: 3.84,
    fill: "#F96C44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.279,
    y: 118.84,
    width: 118.08,
    height: 46.0799,
    rx: 3.84,
    fill: "#F78956"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.279,
    y: 172.6,
    width: 118.08,
    height: 46.0799,
    rx: 3.84,
    fill: "#F78956"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.16,
    y: 149.08,
    width: 64.32,
    height: 31.68,
    rx: 1.92,
    fill: "#F7C056"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.879,
    y: 192.279,
    width: 26.88,
    height: 7.67999,
    rx: 1.92,
    fill: "#F96C44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.726 207.159C178.798 207.369 154.375 210.925 144.876 223.865C143.912 225.445 143.019 228.282 144.09 230.956C139.748 233.375 136.219 237.693 142.097 243.701C144.206 245.856 152.417 246.78 164.084 246.78C164.923 246.945 165.851 247.157 166.864 247.388C175.714 249.405 191.097 252.911 211 240.108V222.041H206.438C206.327 221.735 206.146 221.446 205.891 221.194L192.346 207.816C191.913 207.389 191.334 207.148 190.726 207.159Z",
    fill: "#F4C7A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.28 230.68C147.139 232.491 152.44 235.96 167.32 230.68",
    stroke: "#ECB087",
    strokeWidth: 1.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.54 204.002L198.32 202.113C200.042 201.695 201.827 202.51 202.639 204.086L220.083 237.952C221.129 239.981 220.183 242.479 218.018 243.201C210.227 245.798 205.099 246.212 202.56 245.988C201.704 245.912 200.982 245.373 200.5 244.66C189.118 227.832 187.928 215.81 187.597 207.89C187.52 206.06 188.761 204.433 190.54 204.002Z",
    fill: "#E9F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.049 198.422C248.718 180.278 301.954 150.98 338.2 125.561L369.13 103.869C371.675 102.085 375.16 103.916 375.16 107.024V197.478C375.16 198.733 374.543 199.913 373.509 200.624C304.705 247.86 221.716 256.505 211.24 244.6C203.508 235.814 198.536 214.561 196.584 202.558C196.293 200.764 197.342 199.046 199.049 198.422Z",
    fill: "#1B92FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1619",
    x: 0,
    y: 0,
    width: 347,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_1_1619",
    x: 0,
    y: 0,
    width: 347,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1619",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.958805 0 0 0 0 0.958805 0 0 0 0 0.958805 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_1619"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_1619",
    x: 56,
    y: 0,
    width: 291,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0 0.881852 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1619",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLanding01Medium);
export default __webpack_public_path__ + "static/media/img_landing_01_medium.f7ca9b7a361d7e16606b747fb54fa14b.svg";
export { ForwardRef as ReactComponent };